import React, { FC } from 'react';
import { StrawStageContent } from '../../../common/model/dto/straw-stage-content';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import OvListTable from '../atoms/OvListTable';
import OvListTableRow from '../atoms/OvListTableRow';
import OvListTableHeaderField from '../atoms/OvListTableHeaderField';
import OvStrawStageContentListRow from './OvStrawStageContentListRow';

interface OvStrawStageContentsListProps {
  strawStageContents: StrawStageContent[];
}

const OvStrawStageContentsList: FC<OvStrawStageContentsListProps> = ({
  strawStageContents,
}) => {
  const { t } = useTranslation();

  const headerNames = [
    {
      name: 'strawStageContents.headers.strawStage',
    },
    {
      name: 'strawStageContents.headers.cluster',
    },
    {
      name: 'strawStageContents.headers.name',
    },
    {
      name: 'strawStageContents.headers.predictedPhaseLength',
    },
    { name: 'common.action' },
  ];

  return (
    <WrapperBox>
      <OvListTable>
        <OvListTableRow>
          {headerNames.map(({ name }) => (
            <OvListTableHeaderField style={{ cursor: 'pointer' }}>
              {t(name)}
            </OvListTableHeaderField>
          ))}
        </OvListTableRow>

        {strawStageContents.map((strawStageContent) => (
          <OvListTableRow key={strawStageContent.id}>
            <OvStrawStageContentListRow strawStageContent={strawStageContent} />
          </OvListTableRow>
        ))}
      </OvListTable>
    </WrapperBox>
  );
};

export default OvStrawStageContentsList;

const WrapperBox = styled.div`
  padding: 1.5rem 1rem 1rem;
  overflow-x: auto;
`;
